import React, { useState, useEffect } from 'react';
import {
  User, Calculator, Check, X,
  Clock, AlertTriangle, CheckCircle, Calendar, Users,
  CreditCard, Search,
  Building, ArrowLeft, FolderOpen, ChevronLeft,AlertCircle, Brain, Banknote, ChevronRight, BookOpen, DollarSign, Badge
} from 'lucide-react';
import { api } from '../services/api';
import { motion } from 'framer-motion';
import ConfirmDialog from './ConfirmDialog';
import { Toast } from "../components/ui/Toast";
import EmployeePaimentHistory from './EmployeePaimentHistory';
import { SalaryModificationHistoryModal, SalaryModificationRequestModal } from './SalaryModificationModals';
import NoticePaiementCourte from './paie/NoticePaiementCourte';


const ComptabilitePersonnel = ({
  selectedDate,
  setSelectedDate,
  showCalendar,
  setShowCalendar,
  modesPaiement,
  loadModesPaiement,
  anneeActive,
  showToast,
  formatDateForDisplay,
  goToPreviousMonth,
  goToNextMonth,
  onBackToDashboard,
  salaryAuthorization
}) => {
  // États locaux
  const [employes, setEmployes] = useState([]);
  const [selectedEmploye, setSelectedEmploye] = useState('');
  const [loadingEmployes, setLoadingEmployes] = useState(false);
  const [loading, setLoading] = useState(false);
  const [searchTermEmploye, setSearchTermEmploye] = useState('');
  const [paiementExistantEmploye, setPaiementExistantEmploye] = useState(null);
  const [calculationValidatedEmploye, setCalculationValidatedEmploye] = useState(false);
  const [paymentValidatedEmploye, setPaymentValidatedEmploye] = useState(false);
  const [showJustificationValidationModal, setShowJustificationValidationModal] = useState(false);
  const [justificationValidation, setJustificationValidation] = useState('');
  const [showValidationDialogEmploye, setShowValidationDialogEmploye] = useState(false);
  const [isValidatingEmploye, setIsValidatingEmploye] = useState(false);
  const [showJustificationModal, setShowJustificationModal] = useState(false);
  const [showRetenueModal, setShowRetenueModal] = useState(false);
  const [selectedPresence, setSelectedPresence] = useState(null);
  const [justificationDecalage, setJustificationDecalage] = useState('');
  const [retenueAbsence, setRetenueAbsence] = useState('');
  const [typeRetenue, setTypeRetenue] = useState('avec');
  const [justificationPasDeRetenue, setJustificationPasDeRetenue] = useState('');
  const [showPaymentDialogEmploye, setShowPaymentDialogEmploye] = useState(false);
  const [isProcessingPaymentEmploye, setIsProcessingPaymentEmploye] = useState(false);
  const [selectedModePaiementEmploye, setSelectedModePaiementEmploye] = useState('');
  const [showCloturePaiementEmployeDialog, setShowCloturePaiementEmployeDialog] = useState(false);
  const [showHistoriqueEmployes, setShowHistoriqueEmployes] = useState(false);
  const [salaryRequestEmploye, setSalaryRequestEmploye] = useState(null);
  const [salaryHistoryEmploye, setSalaryHistoryEmploye] = useState(null);
  const [toast, setToast] = useState({ show: false, message: '', type: '' });


  const [paymentStep, setPaymentStep] = useState('payment'); // 🆕 'payment' ou 'cloture'

    // 🆕 Ajoute cet état pour le modal enfants à charge
  const [showModalEnfantsCharge, setShowModalEnfantsCharge] = useState(false);
  const [selectedEmployeEnfantsDetail, setSelectedEmployeEnfantsDetail] = useState(null);

  const [isModePaiementDropdownOpen, setIsModePaiementDropdownOpen] = useState(false);
  const [modePaiementSearchTerm, setModePaiementSearchTerm] = useState('');



  // Charger les employés au montage et quand la date change
  useEffect(() => {
    loadEmployesData();
  }, [selectedDate]);

  useEffect(() => {
    loadModesPaiement();
  }, []);

  useEffect(() => {
    if (toast.show) {
      const timer = setTimeout(() => {
        setToast({ show: false, message: '', type: '' });
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [toast]);

  const localShowToast = (message, type = 'success') => {
    setToast({ show: true, message, type });
  };

  const salaryPaymentLocked = salaryAuthorization?.paiement_autorise === false;
  const salaryLockReasons = salaryAuthorization?.raisons_blocage || [];
  const getSalaryLockMessage = () => salaryLockReasons[0] || "Paiement des salaires verrouillé. Validez l'état des salaires et la dotation centrale avant paiement.";

  const SalaryLockPanel = () => salaryPaymentLocked ? (
    <div className="mb-3 rounded-lg border border-amber-200 bg-amber-50 p-3 text-sm text-amber-900">
      <div className="flex items-start gap-2">
        <AlertTriangle className="mt-0.5 h-4 w-4 flex-shrink-0" />
        <div>
          <p className="font-semibold">Paiement verrouille</p>
          <p className="text-xs">{getSalaryLockMessage()}</p>
        </div>
      </div>
    </div>
  ) : null;


  // Fermer les dropdowns au clic extérieur
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isModePaiementDropdownOpen && !event.target.closest('.mode-paiement-dropdown')) {
        setIsModePaiementDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isModePaiementDropdownOpen]);



  const loadEmployesData = async () => {
    setLoadingEmployes(true);
    try {
      const mois = selectedDate.getMonth() + 1;
      const annee = selectedDate.getFullYear();

      console.log(`📊 Chargement des employés pour ${mois}/${annee}...`);

      const selectedYearId = anneeActive?.id || localStorage.getItem('annee_scolaire_id');
      const response = await api.comptabilite.getPointagesMensuelsEmployes(mois, annee, selectedYearId);

      if (response.success) {
        console.log(`✅ ${response.data.length} employés chargés`);

        const employesAvecPaiements = await Promise.all(
          response.data.map(async (employe) => {
            try {
              console.log(`🔍 Vérification paiement pour ${employe.prenom} ${employe.nom} (ID: ${employe.id})`);

              const paiementResponse = await api.paiementsSalaires.verifierPaiementEmployeExistant(
                employe.id,
                mois,
                annee
              );

              console.log(`📄 Réponse paiement employé ${employe.id}:`, paiementResponse);

              const paiementExiste = paiementResponse.success && paiementResponse.existe;
              const paiementInfo = paiementResponse.paiement || null;

              console.log(`${paiementExiste ? '✅' : '❌'} Employé ${employe.prenom} ${employe.nom}: ${paiementExiste ? 'PAYÉ' : 'PAS PAYÉ'}`);
              if (paiementInfo) {
                console.log(`   → Statut: ${paiementInfo.statut}, ID: ${paiementInfo.id}`);
              }

              const avances = paiementResponse.avances || [];
              const montant_avances = paiementResponse.montant_avances || 0;

              return {
                ...employe,
                paiement_existe: paiementExiste,
                paiement_info: paiementInfo,
                avances_mois: avances,
                montant_avances_total: montant_avances
              };

            } catch (error) {
              console.error(`❌ Erreur vérification paiement employé ${employe.id}:`, error);
              return {
                ...employe,
                paiement_existe: false,
                paiement_info: null
              };
            }
          })
        );

        console.log('✅ Tous les paiements vérifiés');
        console.log('📋 Employés avec infos paiement:', employesAvecPaiements);

        employesAvecPaiements.forEach(emp => {
          console.log(`📊 ${emp.prenom} ${emp.nom}:`, {
            paiement_existe: emp.paiement_existe,
            avances: emp.paiement_info?.avances || [],
            montant_avances: emp.paiement_info?.montant_avances || 0
          });
        });

        setEmployes(employesAvecPaiements);

      } else {
        localShowToast(response.message || 'Erreur lors du chargement', 'error');
      }
    } catch (error) {
      console.error('❌ Erreur chargement employés:', error);
      localShowToast('Erreur lors du chargement des employés', 'error');
    } finally {
      setLoadingEmployes(false);
    }
  };


    const calculerRemunerationEmploye = (employe) => {
    if (!employe || !employe.presences) {
        return {
        salaire_base: 0,
        total_retenues: 0,
        total_avances: 0,
        salaire_net: 0,
        jours_ouvres_attendus: 0,
        jours_pointes: 0,
        jours_manquants: 0,
        jours_non_travailles: 0,
        peut_payer: false,
        message_erreur: null,
        // 🆕 Retenues enfants par défaut
        retenues_enfants_charge: 0,
        nombre_enfants_charge: 0
        };
    }

    const mois = selectedDate.getMonth();
    const annee = selectedDate.getFullYear();
    const joursOuvres = [];

    const premierJour = new Date(annee, mois, 1, 12, 0, 0);
    const dernierJour = new Date(annee, mois + 1, 0, 12, 0, 0);

    for (let jour = new Date(premierJour); jour <= dernierJour; jour.setDate(jour.getDate() + 1)) {
        const jourSemaine = jour.getDay();
        if (jourSemaine !== 0) {
        const dateStr = `${jour.getFullYear()}-${String(jour.getMonth() + 1).padStart(2, '0')}-${String(jour.getDate()).padStart(2, '0')}`;
        joursOuvres.push(dateStr);
        }
    }

    const datesPointees = employe.presences.map(p => p.date);
    const joursManquants = joursOuvres.filter(jour => !datesPointees.includes(jour));
     // Compter les jours non travaillés
    const joursNonTravailles = employe.presences.filter(p => p.statut === 'jour_non_travaille').length;

    // Compter les vraies absences (exclure les jours non travaillés)
    const vraisAbsences = employe.presences.filter(p => p.statut === 'absent').length;

    // Calcul des retenues présences
    let totalRetenuesPresences = 0;
    employe.presences.forEach(p => {
        if (p.retenue_absence && p.retenue_absence > 0) {
        totalRetenuesPresences += parseFloat(p.retenue_absence);
        }
    });

    // Retenue globale (manuelle)
    let retenueGlobale = 0;
    if (employe.retenue_temp && employe.retenue_temp > 0) {
        retenueGlobale = parseFloat(employe.retenue_temp);
    }

    // 🆕 Retenues enfants à charge (automatiques)
      const retenuesEnfantsLocaux = employe.retenues_enfants_charge?.montant_total || 0;
      const retenuesEnfantsIntersite = employe.retenues_enfants_charge?.intersite?.montant_total || 0;
      const retenuesEnfantsCharge = employe.retenues_enfants_charge?.total_unifie || retenuesEnfantsLocaux;
      const nombreEnfantsLocaux = employe.retenues_enfants_charge?.nombre_enfants || 0;
      const nombreEnfantsIntersite = employe.retenues_enfants_charge?.intersite?.nombre_enfants || 0;
      const nombreEnfantsCharge = nombreEnfantsLocaux + nombreEnfantsIntersite;
      const detailEnfantsCharge = employe.retenues_enfants_charge?.detail_enfants || [];
      const detailEnfantsIntersite = employe.retenues_enfants_charge?.intersite?.detail_enfants || [];




    // 🆕 Total retenues = présences + globale + enfants à charge
    const totalRetenues = totalRetenuesPresences + retenueGlobale + retenuesEnfantsCharge;

    // Calcul des avances
    let totalAvances = 0;
    if (employe.avances_mois && Array.isArray(employe.avances_mois)) {
        totalAvances = employe.avances_mois.reduce((sum, avance) => {
        if (avance.statut === 'validee' || avance.statut === 'appliquee') {
            return sum + parseFloat(avance.montant || 0);
        }
        return sum;
        }, 0);
    }

    const salaireBase = parseFloat(employe.salaire_fixe) || 0;
    const salaireNet = salaireBase - totalRetenues - totalAvances;

    return {
        salaire_base: salaireBase,
        total_retenues: totalRetenues,
        total_retenues_presences: totalRetenuesPresences,
        retenue_globale: retenueGlobale,
        retenues_enfants_charge: retenuesEnfantsCharge,
        nombre_enfants_charge: nombreEnfantsCharge,
        detail_enfants_charge: detailEnfantsCharge,
        retenues_enfants_locaux: retenuesEnfantsLocaux,
        retenues_enfants_intersite: retenuesEnfantsIntersite,
        nombre_enfants_locaux: nombreEnfantsLocaux,
        nombre_enfants_intersite: nombreEnfantsIntersite,
        detail_enfants_intersite: detailEnfantsIntersite,
        total_avances: totalAvances,
        salaire_net: salaireNet,
        jours_ouvres_attendus: joursOuvres.length,
        jours_pointes: datesPointees.length,
        jours_manquants: joursManquants.length,
        jours_non_travailles: joursNonTravailles,  // ✅ AJOUTE
        vrais_absences: vraisAbsences,  // ✅ AJOUTE
        dates_manquantes: joursManquants,
        peut_payer: joursManquants.length === 0,
        message_erreur: joursManquants.length > 0
        ? `${joursManquants.length} jour(s) sans pointage`
        : null
    };
    };




  const handleOpenJustificationDecalage = (presence) => {
    setSelectedPresence(presence);
    setJustificationDecalage(presence.justification_decalage || '');
    setShowJustificationModal(true);
  };

  const handleOpenRetenueAbsence = (presence) => {
    setSelectedPresence(presence);
    setRetenueAbsence(presence.retenue_absence || '');
    setTypeRetenue(presence.retenue_absence !== null ? 'avec' : 'sans');
    setJustificationPasDeRetenue(presence.justification_pas_de_retenue || '');
    setShowRetenueModal(true);
  };

  const handleSaveJustificationDecalage = async () => {
    if (!justificationDecalage.trim()) {
      localShowToast('Veuillez saisir une justification', 'error');
      return;
    }

    try {
      setLoading(true);
      const response = await api.comptabilite.updateJustificationDecalage(
        selectedPresence.id,
        justificationDecalage
      );

      if (response.success) {
        localShowToast('Justification enregistrée', 'success');
        setShowJustificationModal(false);
        loadEmployesData();
      } else {
        localShowToast(response.message || 'Erreur lors de l\'enregistrement', 'error');
      }
    } catch (error) {
      console.error('Erreur:', error);
      localShowToast('Erreur lors de l\'enregistrement', 'error');
    } finally {
      setLoading(false);
    }
  };

  const handleSaveRetenueAbsence = async () => {
    if (typeRetenue === 'avec' && !retenueAbsence) {
      localShowToast('Veuillez saisir le montant de la retenue', 'error');
      return;
    }

    if (!justificationPasDeRetenue.trim()) {
      localShowToast('Veuillez saisir une justification', 'error');
      return;
    }

    try {
      localShowToast('Enregistrement de la retenue en cours...', 'loading');

      const montant = typeRetenue === 'avec' ? parseFloat(retenueAbsence) : 0;
      const justification = justificationPasDeRetenue.trim();

      console.log('💾 Retenue enregistrée temporairement (EMPLOYÉ):', {
        employe_id: selectedPresence?.employe_id,
        montant,
        justification,
        typeRetenue
      });

      setEmployes(prev => prev.map(emp => {
        if (emp.id === selectedPresence?.employe_id) {
          const updatedEmp = {
            ...emp,
            retenue_temp: montant,
            justification_retenue_temp: justification
          };

          console.log('✅ Employé mis à jour dans le state:', {
            id: updatedEmp.id,
            nom: `${updatedEmp.prenom} ${updatedEmp.nom}`,
            retenue_temp: updatedEmp.retenue_temp,
            justification: updatedEmp.justification_retenue_temp
          });

          return updatedEmp;
        }
        return emp;
      }));

      setShowRetenueModal(false);

      if (typeRetenue === 'avec') {
        localShowToast(`Retenue de ${montant.toLocaleString()} FCFA enregistrée. Elle sera déduite lors du paiement.`, 'success');
      } else {
        localShowToast('Absence de retenue enregistrée avec justification.', 'success');
      }

    } catch (error) {
      console.error('💥 Erreur enregistrement retenue employé:', error);
      localShowToast('Erreur lors de l\'enregistrement', 'error');
    }
  };

  const handleOpenPaymentDialogEmploye = () => {
  if (salaryPaymentLocked) {
    localShowToast(getSalaryLockMessage(), 'error');
    return;
  }
  console.log('🔍 Modes de paiement disponibles:', modesPaiement);
  console.log('📊 Nombre de modes:', modesPaiement?.length || 0);

  // 🆕 Réinitialiser les états du dropdown
  setModePaiementSearchTerm('');
  setIsModePaiementDropdownOpen(false);

  setShowPaymentDialogEmploye(true);
};


 const handleProcessPaymentEmploye = async () => {
  if (salaryPaymentLocked) {
    localShowToast(getSalaryLockMessage(), 'error');
    return;
  }

  if (!selectedModePaiementEmploye) {
    localShowToast('Veuillez sélectionner un mode de paiement', 'error');
    return;
  }

  setShowPaymentDialogEmploye(false);
  setIsProcessingPaymentEmploye(true);
  setPaymentStep('payment'); // 🆕 Commencer par l'étape paiement

  try {
    const employe = employes.find(e => e.id.toString() === selectedEmploye);
    const calcul = calculerRemunerationEmploye(employe);

    const justificationRetenue = employe.justification_retenue_temp || null;

    console.log('💰 ÉTAPE 1/2 : Paiement employé:', {
      employe_id: parseInt(selectedEmploye),
      montant_brut: calcul.salaire_base,
      montant_retenues: calcul.total_retenues,
      montant_net: calcul.salaire_net
    });

    // 🆕 ÉTAPE 1 : PAIEMENT (8 secondes)
    const response = await api.paiementsSalaires.creerPaiementEmploye({
      employe_id: parseInt(selectedEmploye),
      mois: selectedDate.getMonth() + 1,
      annee: selectedDate.getFullYear(),
      annee_scolaire_id: anneeActive?.id || null,
      montant_brut: calcul.salaire_base,
      montant_retenues: calcul.total_retenues,
      justification_retenue: justificationRetenue,
      montant_avances: calcul.total_avances,
      montant_net: calcul.salaire_net,
      mode_paiement_id: parseInt(selectedModePaiementEmploye),
      justification_pointages_manquants: justificationValidation || null,
      jours_ouvres: calcul.jours_ouvres_attendus,
      jours_pointes: calcul.jours_pointes,
      jours_manquants: calcul.jours_manquants
    });

    if (!response.success) {
      localShowToast(response.message || response.error || 'Erreur lors du paiement', 'error');
      setIsProcessingPaymentEmploye(false);
      return;
    }

    console.log('✅ ÉTAPE 1/2 : Paiement enregistré avec succès');

    // Attendre 8 secondes pour laisser lire l'étape 1
    await new Promise(resolve => setTimeout(resolve, 8000));

    // 🆕 ÉTAPE 2 : CLÔTURE (5 secondes)
    setPaymentStep('cloture');
    console.log('🔒 ÉTAPE 2/2 : Clôture du paiement ID:', response.data.id);

    const cloureResponse = await api.paiementsSalaires.cloturerPaiementEmploye(response.data.id);

    if (!cloureResponse.success) {
      localShowToast('Paiement effectué mais échec de la clôture', 'warning');
      setPaiementExistantEmploye(response.data);
      setPaymentValidatedEmploye(true);
      setCalculationValidatedEmploye(true);
      setIsProcessingPaymentEmploye(false);
      return;
    }

    console.log('✅ ÉTAPE 2/2 : Paiement clôturé avec succès');

    // Attendre 5 secondes pour laisser lire l'étape 2
    await new Promise(resolve => setTimeout(resolve, 5000));

    // 🆕 Marquer les avances comme appliquées
    if (employe.avances_mois && employe.avances_mois.length > 0) {
      console.log(`📝 Marquage de ${employe.avances_mois.length} avance(s) comme appliquée(s)...`);

      for (const avance of employe.avances_mois) {
        if (avance.statut === 'validee') {
          try {
            const markResponse = await api.avancesSalaire.marquerAvanceAppliquee(avance.id);
            if (markResponse.success) {
              console.log(`✅ Avance ${avance.id} (${avance.montant} FCFA) marquée comme appliquée`);
            }
          } catch (error) {
            console.error(`❌ Erreur marquage avance ${avance.id}:`, error);
          }
        }
      }
    }

    // 🆕 Mettre à jour l'état avec le paiement clôturé
    setPaiementExistantEmploye({
      ...response.data,
      statut: 'cloture',
      date_cloture: new Date().toISOString()
    });
    setPaymentValidatedEmploye(true);
    setCalculationValidatedEmploye(true);

    // Recharger les données
    await loadEmployesData();

    if (calcul.total_avances > 0) {
      localShowToast(
        `Paiement clôturé avec succès. ${calcul.total_avances.toLocaleString()} FCFA d'avances appliquées.`,
        'success'
      );
    } else {
      localShowToast('Paiement clôturé avec succès', 'success');
    }

  } catch (error) {
    console.error('❌ Erreur lors du traitement:', error);
    localShowToast(error.message || 'Erreur lors du traitement du paiement', 'error');
  } finally {
    setIsProcessingPaymentEmploye(false);
    setPaymentStep('payment'); // Reset
  }
};




 const handleCloturerPaiementEmploye = async () => {
  if (!paiementExistantEmploye || !paiementExistantEmploye.id) {
    localShowToast('Aucun paiement à clôturer', 'error');
    return;
  }

  try {
    localShowToast('Clôture du paiement en cours...', 'loading');
    setShowCloturePaiementEmployeDialog(false);

    console.log(`🔒 Clôture du paiement employé ID: ${paiementExistantEmploye.id}`);

    const response = await api.paiementsSalaires.cloturerPaiementEmploye(paiementExistantEmploye.id);

    if (response.success) {
      // Recharger les données de l'employé
      await loadEmployesData();

      // Mettre à jour l'état du paiement existant
      setPaiementExistantEmploye(prev => ({
        ...prev,
        statut: 'cloture',
        date_cloture: new Date().toISOString()
      }));

      localShowToast('Paiement clôturé avec succès !', 'success');
    } else {
      localShowToast(response.message || 'Échec de la clôture', 'error');
    }
  } catch (error) {
    console.error('❌ Erreur clôture:', error);
    localShowToast('Erreur lors de la clôture du paiement', 'error');
  }
};

  const handleValidateCalculationEmploye = async () => {
  if (salaryPaymentLocked) {
    setShowValidationDialogEmploye(false);
    localShowToast(getSalaryLockMessage(), 'error');
    return;
  }

  try {
    setShowValidationDialogEmploye(false);
    setIsValidatingEmploye(true);  // 🆕 Utiliser le dialog au lieu du toast

    await new Promise(resolve => setTimeout(resolve, 3000));

    setCalculationValidatedEmploye(true);
    localShowToast('Calcul validé - Vous pouvez maintenant effectuer le paiement', 'success');

  } catch (error) {
    console.error('Erreur validation:', error);
    localShowToast('Erreur lors de la validation', 'error');
  } finally {
    setIsValidatingEmploye(false);  // 🆕 Fermer le dialog
  }
};

  const handleDownloadFichePaieEmploye = async (paiementId) => {
    try {
      localShowToast('Génération de la fiche de paie en cours...', 'loading');

      console.log('📄 Demande de génération fiche paie employé:', paiementId);

      await api.paiementsSalaires.genererFichePaieEmploye(paiementId);

      localShowToast('Fiche de paie téléchargée avec succès !', 'success');

    } catch (error) {
      console.error('❌ Erreur téléchargement fiche employé:', error);
      localShowToast(`Erreur: ${error.message || 'Erreur lors du téléchargement'}`, 'error');
    }
  };

  return (
    <div className="space-y-6">
      <div className="bg-white rounded-lg shadow-sm border border-gray-100 overflow-hidden">
        <div className="p-6">
        {/* Bouton retour + En-tête */}
        <div className="bg-white p-5 rounded-lg border border-gray-200 shadow-sm mb-6">
          <div className="flex items-center mb-4">
            <button
              onClick={onBackToDashboard}
              className="flex items-center text-[#246990] hover:text-[#1f5a7a] mr-4"
            >
              <ArrowLeft className="w-5 h-5 mr-2" />
              Retour au dashboard
            </button>
          </div>

          <div className="p-4 bg-[#eef7fb] rounded-lg border border-[#246990]/20 flex items-center mb-5">
            <div className="p-2 bg-[#246990] rounded-full mr-4">
              <Building className="text-white" size={20} />
            </div>
            <div className="flex-1">
              <h1 className="font-medium text-[#246990] text-xl">Personnel administratif</h1>
              <p className="text-sm text-gray-600">Gestion des salaires fixes</p>
            </div>
            <div className="text-right">
              <div className="text-sm text-gray-500">Période sélectionnée</div>
              <div className="font-medium text-gray-800 capitalize">
                {formatDateForDisplay(selectedDate)}
              </div>
              <div className="text-xs text-gray-500">Salaires mensuels</div>
            </div>
          </div>


          {/* Rappel avant paiement (version courte, voir SalaryManagementPage) */}
          <NoticePaiementCourte />

          {/* Navigation de période */}
        <div className="flex items-center justify-end space-x-2 bg-gray-50 rounded-lg p-2">
          <button
            onClick={goToPreviousMonth}
            className="p-2 text-gray-600 hover:text-gray-900 hover:bg-white rounded-md transition-colors"
          >
            <ChevronLeft className="w-4 h-4" />
          </button>

          <div className="relative">
            <button
              onClick={() => setShowCalendar(!showCalendar)}
              className="flex items-center px-4 py-2 bg-white border border-gray-200 rounded-md hover:bg-gray-50 transition-colors"
            >
              <Calendar className="h-4 w-4 mr-2 text-[#246990]" />
              <span className="text-sm font-medium text-gray-900 capitalize">
                {formatDateForDisplay(selectedDate)}
              </span>
            </button>

            {showCalendar && (
              <div className="absolute top-full mt-2 right-0 bg-white border border-gray-200 rounded-lg shadow-lg z-50 p-4">
                <input
                  type="month"
                  value={`${selectedDate.getFullYear()}-${String(selectedDate.getMonth() + 1).padStart(2, '0')}`}
                  onChange={(e) => {
                    const [year, month] = e.target.value.split('-');
                    const newDate = new Date(parseInt(year), parseInt(month) - 1, 1);
                    setSelectedDate(newDate);
                    setShowCalendar(false);
                  }}
                  className="p-2 border border-gray-300 rounded-md"
                />
              </div>
            )}
          </div>

          <button
            onClick={goToNextMonth}
            className="p-2 text-gray-600 hover:text-gray-900 hover:bg-white rounded-md transition-colors"
          >
            <ChevronRight className="w-4 h-4" />
          </button>

        <button
          onClick={() => setShowHistoriqueEmployes(true)}
          className="px-3 py-2 text-xs bg-[#246990] text-white rounded-md hover:bg-[#246990]/90 transition-colors flex items-center"
        >
          <FolderOpen className="w-3 h-3 mr-1" />
         Registre comptable
        </button>
        </div>
        </div>

        {/* Grille 3 colonnes */}
        <div className="grid grid-cols-1 xl:grid-cols-12 gap-4">
          {/* Section 1: Liste des employés */}
          <div className="bg-white p-4 rounded-lg border border-gray-200 shadow-sm xl:col-span-2">
            <div className="p-3 bg-[#eef7fb] rounded-lg border border-[#246990]/20 flex items-center mb-4">
              <div className="p-2 bg-[#246990] rounded-full mr-2">
                <Building className="text-white" size={14} />
              </div>
              <div className="flex-1">
                <h2 className="font-medium text-[#246990] text-base">Personnel</h2>
                <p className="text-xs text-gray-600">Sélection</p>
              </div>
            </div>

            {/* Barre de recherche */}
            <div className="mb-3">
              <div className="relative">
                <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={14} />
                <input
                  type="text"
                  placeholder="Rechercher..."
                  value={searchTermEmploye}
                  onChange={(e) => setSearchTermEmploye(e.target.value)}
                  className="w-full pl-9 pr-3 py-2 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#246990] focus:border-transparent"
                />
              </div>
            </div>

            {/* Liste des employés */}
            <div className="space-y-2 max-h-[500px] overflow-y-auto">
              {loadingEmployes ? (
                <div className="text-center py-8 text-gray-400">
                  <div className="animate-spin w-8 h-8 border-4 border-[#246990] border-t-transparent rounded-full mx-auto"></div>
                  <p className="text-sm mt-2">Chargement...</p>
                </div>
              ) : employes.length === 0 ? (
                <div className="text-center py-8 text-gray-400">
                  <Building className="w-12 h-12 mx-auto mb-2 opacity-50" />
                  <p className="text-sm">Aucun employé trouvé</p>
                </div>
              ) : (
                employes
                  .filter(e =>
                    `${e.prenom} ${e.nom}`.toLowerCase().includes(searchTermEmploye.toLowerCase())
                  )
                  .map((employe) => (

                    <div
          key={employe.id}
          onClick={() => {
            setSelectedEmploye(employe.id.toString());

            if (employe.paiement_existe && employe.paiement_info) {
              console.log(`✅ Employé ${employe.prenom} ${employe.nom} déjà payé ce mois`);
              setPaiementExistantEmploye(employe.paiement_info);
              setPaymentValidatedEmploye(true);
              setCalculationValidatedEmploye(true);
            } else {
              console.log(`ℹ️ Employé ${employe.prenom} ${employe.nom} pas encore payé ce mois`);
              setPaiementExistantEmploye(null);
              setPaymentValidatedEmploye(false);
              setCalculationValidatedEmploye(false);
            }
          }}
          className={`p-2 rounded-lg border cursor-pointer transition-all ${
            selectedEmploye === employe.id.toString()
              ? 'border-[#246990] bg-blue-50 shadow-sm'
              : 'border-gray-200 hover:border-gray-300 bg-white hover:bg-gray-50'
          }`}
        >
          <div className="flex items-center justify-between">
            <div className="flex-1 min-w-0">
              {/* Nom + Badge "Payé" */}
              <div className="flex items-center gap-2">
                <div className={`text-sm font-medium truncate ${
                  selectedEmploye === employe.id.toString() ? 'text-[#246990]' : 'text-gray-900'
                }`}>
                  {employe.prenom} {employe.nom}
                </div>

                {/* Badge si déjà payé */}
                {employe.paiement_existe && (
                  <span className="text-xs px-2 py-0.5 bg-green-100 text-green-800 rounded-full flex-shrink-0">
                    ✓ Payé
                  </span>
                )}
              </div>

              {/* Poste */}
              <div className="text-xs text-gray-500">{employe.poste || 'Employé'}</div>
            </div>
          </div>
        </div>
                  ))
              )}
            </div>
          </div>


          {/* Section 2: Calcul du salaire */}
          <div className={`bg-white p-5 rounded-lg border border-gray-200 shadow-sm xl:col-span-8 ${
            paiementExistantEmploye?.statut === 'cloture' ? 'opacity-50 pointer-events-none' : ''
          }`}>
          <div className="p-4 bg-[#eef7fb] rounded-lg border border-[#246990]/20 flex items-center mb-5">
            <div className="p-2 bg-[#246990] rounded-full mr-3">
              <Calculator className="text-white" size={16} />
            </div>
            <div className="flex-1">
              <h2 className="font-medium text-[#246990] text-lg">Calcul du salaire</h2>
              <p className="text-sm text-gray-600">Salaire fixe et éléments variables</p>
            </div>
          </div>

          {!selectedEmploye ? (
            <div className="text-center py-12 text-gray-400">
              <Calculator className="h-16 w-16 mx-auto mb-4 opacity-50" />
              <h4 className="text-lg font-medium text-gray-700 mb-2">Aucun employé sélectionné</h4>
              <p className="text-sm">Sélectionnez un employé pour voir ses données</p>
            </div>
          ) : (() => {
            const employe = employes.find(e => e.id.toString() === selectedEmploye);

            if (!employe) {
              return (
                <div className="text-center py-12 text-gray-400">
                  <AlertTriangle className="h-16 w-16 mx-auto mb-4 opacity-50" />
                  <h4 className="text-lg font-medium text-gray-700 mb-2">Données non disponibles</h4>
                </div>
              );
            }

            const presences = employe.presences || [];
            const stats = employe.statistiques || {};

            return (

              <div className="space-y-4">
              {/* Résumé employé */}
            <div className="p-3 bg-blue-50 rounded-lg border border-blue-200">
              <div className="flex items-center justify-between">
                <div>
                  <div className="font-medium text-blue-900">
                    {employe.prenom} {employe.nom}
                  </div>
                  <div className="text-sm text-blue-700">
                    {employe.poste || 'Employé'} - {employe.type_contrat || 'Non défini'}
                  </div>
                </div>
                <div className="text-right">
                  <div className="text-sm font-medium text-blue-900">
                    {employe.salaire_fixe || 0} FCFA
                  </div>
                  <div className="text-xs text-blue-700">Salaire de base</div>
                  {employe.salaire_source === 'modification' && (
                    <div className="mt-1 text-[11px] font-semibold text-emerald-700">
                      Modification validee appliquee ce mois
                    </div>
                  )}
                  <div className="mt-2 flex justify-end gap-2">
                    <button
                      type="button"
                      onClick={() => setSalaryRequestEmploye(employe)}
                      className="rounded-md border border-blue-200 bg-white px-2 py-1 text-xs font-semibold text-[#246990] hover:bg-blue-50"
                    >
                      Modifier
                    </button>
                    <button
                      type="button"
                      onClick={() => setSalaryHistoryEmploye(employe)}
                      className="rounded-md border border-slate-200 bg-white px-2 py-1 text-xs font-semibold text-slate-600 hover:bg-slate-50"
                    >
                      Historique
                    </button>
                  </div>
                </div>
              </div>
            </div>


            {/* Statistiques */}
          <div className="grid grid-cols-3 gap-3">
            {/* Jours travaillés */}
            <div className="p-3 bg-green-50 rounded-lg border border-green-200">
              <div className="text-center">
                <div className="text-xl font-bold text-green-600">{employe.nombre_presences || 0}</div>
                <div className="text-xs text-green-700">Jours travaillés</div>
              </div>
            </div>

            {/* Absences (vraies absences uniquement) */}
            <div className="p-3 bg-red-50 rounded-lg border border-red-200">
              <div className="text-center">
                <div className="text-xl font-bold text-red-600">
                  {(() => {
                    const calcul = calculerRemunerationEmploye(employe);
                    return calcul.vrais_absences || 0;
                  })()}
                </div>
                <div className="text-xs text-red-700">Absences</div>
              </div>
            </div>

            {/* Jours non travaillés */}
            <div className="p-3 bg-gray-50 rounded-lg border border-gray-200">
              <div className="text-center">
                <div className="text-xl font-bold text-gray-600">
                  {(() => {
                    const calcul = calculerRemunerationEmploye(employe);
                    return calcul.jours_non_travailles || 0;
                  })()}
                </div>
                <div className="text-xs text-gray-700">Jours non travaillés</div>
              </div>
            </div>
          </div>



            {/* Tableau des présences */}
            <div className="border border-gray-200 rounded-lg overflow-hidden">
              <div className="bg-gray-50 px-3 py-2 border-b border-gray-200">
                <h4 className="text-sm font-medium text-gray-700">Détail des présences</h4>
              </div>

              {employe.presences && employe.presences.length === 0 ? (
                <div className="p-6 text-center text-gray-400">
                  <Clock className="w-12 h-12 mx-auto mb-2 opacity-50" />
                  <p className="text-sm">Aucune donnée de présence pour cette période</p>
                </div>
              ) : (
                <div className="overflow-x-auto max-h-96 overflow-y-auto">
                  <table className="w-full text-sm">
                    <thead className="bg-gray-50 sticky top-0">
                      <tr className="border-b border-gray-200">
                        <th className="px-3 py-2 text-left text-xs font-medium text-gray-600">Date prévue</th>
                        <th className="px-3 py-2 text-left text-xs font-medium text-gray-600">Date pointage</th>
                        <th className="px-3 py-2 text-left text-xs font-medium text-gray-600">Statut</th>
                        <th className="px-3 py-2 text-left text-xs font-medium text-gray-600">Heures</th>
                        <th className="px-3 py-2 text-left text-xs font-medium text-gray-600">Envoyé par</th>
                        <th className="px-3 py-2 text-left text-xs font-medium text-gray-600">Actions</th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-200">
                      {employe.presences && employe.presences.map((presence, index) => {
                        const hasDecalage = presence.jours_decalage > 0;
                        const isAbsent = presence.statut === 'absent';

                        return (
                          <React.Fragment key={index}>
                            <tr className="hover:bg-gray-50">
                              <td className="px-3 py-2 whitespace-nowrap text-xs">
                                {new Date(presence.date).toLocaleDateString('fr-FR')}
                              </td>
                              <td className="px-3 py-2 whitespace-nowrap text-xs">
                                <div className="flex items-center">
                                  {new Date(presence.date_reelle_pointage).toLocaleDateString('fr-FR')}
                                  {hasDecalage && (
                                    <span className="ml-2 px-2 py-0.5 bg-orange-100 text-orange-800 rounded text-xs">
                                      +{presence.jours_decalage}j
                                    </span>
                                  )}
                                </div>
                              </td>
                              <td className="px-3 py-2 whitespace-nowrap">

                               <span className={`text-xs px-2 py-1 rounded-full ${
                                presence.statut === 'present'
                                  ? 'bg-green-100 text-green-800'
                                  : presence.statut === 'jour_non_travaille'
                                    ? 'bg-gray-100 text-gray-800'  // ✅ Badge gris pour jour non travaillé
                                    : 'bg-red-100 text-red-800'
                              }`}>
                                {presence.statut === 'present'
                                  ? 'Présent'
                                  : presence.statut === 'jour_non_travaille'
                                    ? 'Jour non travaillé'  // ✅ Texte différent
                                    : 'Absent'}
                              </span>

                              </td>

                              <td className="px-3 py-2 whitespace-nowrap text-xs">
                                {presence.heures || '-'}
                              </td>
                              <td className="px-3 py-2 whitespace-nowrap text-xs text-gray-600">
                                {presence.envoye_par || 'Système'}
                              </td>
                              <td className="px-3 py-2 whitespace-nowrap">

                               <td className="px-3 py-2 whitespace-nowrap">
                                  <div className="flex gap-1">
                                    {hasDecalage && (
                                      <button
                                        onClick={() => handleOpenJustificationDecalage(presence)}
                                        className="text-xs px-2 py-1 bg-orange-600 text-white rounded hover:bg-orange-700"
                                        title="Justifier le décalage"
                                      >
                                        Justifier
                                      </button>
                                    )}
                                  </div>
                                </td>

                              </td>
                            </tr>

                            {/* Ligne détails - Justification décalage */}
                            {hasDecalage && presence.justification_decalage && (
                              <tr className="bg-orange-50">
                                <td colSpan="6" className="px-3 py-2 text-xs">
                                  <div className="flex items-start">
                                    <AlertCircle className="w-4 h-4 text-orange-600 mr-2 mt-0.5" />
                                    <div>
                                      <span className="font-medium text-orange-900">Justification décalage : </span>
                                      <span className="text-orange-800">{presence.justification_decalage}</span>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            )}

                            {/* Ligne détails - Retenue absence */}
                            {isAbsent && (presence.retenue_absence !== null || presence.justification_pas_de_retenue) && (
                              <tr className="bg-red-50">
                                <td colSpan="6" className="px-3 py-2 text-xs">
                                  {presence.retenue_absence !== null ? (
                                    <div className="flex items-center">

                                      <span className="font-medium text-red-900">Retenue appliquée : </span>
                                      <span className="text-red-800 ml-1">{presence.retenue_absence} F</span>
                                    </div>
                                  ) : (
                                    <div className="flex items-start">
                                      <CheckCircle className="w-4 h-4 text-green-600 mr-2 mt-0.5" />
                                      <div>
                                        <span className="font-medium text-green-900">Pas de retenue - </span>
                                        <span className="text-green-800">{presence.justification_pas_de_retenue}</span>
                                      </div>
                                    </div>
                                  )}
                                </td>
                              </tr>
                            )}

                            {/* Remarques */}
                            {presence.remarques && presence.remarques !== '-' && (
                              <tr className="bg-gray-50">
                                <td colSpan="6" className="px-3 py-2 text-xs text-gray-600">
                                  <span className="font-medium">Remarques : </span>
                                  {presence.remarques}
                                </td>
                              </tr>
                            )}
                          </React.Fragment>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              )}
            </div>


            {/* Message si paiement existant */}
            {paiementExistantEmploye && paiementExistantEmploye.statut === 'cloture' ? (
              <div className="mb-4 p-4 bg-red-100 border-2 border-red-300 rounded-lg">
                <div className="flex items-center mb-2">
                  <AlertTriangle className="w-6 h-6 text-red-600 mr-2" />
                  <h4 className="font-bold text-red-900 text-lg">Paiement cloturé pour cette période</h4>
                </div>
                <div className="text-sm text-red-700 space-y-1">
                  <div>Date : {new Date(paiementExistantEmploye.date_paiement).toLocaleDateString('fr-FR')}</div>
                  <div>Montant : {paiementExistantEmploye.montant_net} F</div>
                  <div>Cloturé le : {paiementExistantEmploye.date_cloture ? new Date(paiementExistantEmploye.date_cloture).toLocaleDateString('fr-FR') : 'N/A'}</div>
                  <div className="font-medium mt-2">Aucune modification n'est possible</div>
                </div>
              </div>
            ) : paiementExistantEmploye ? (
              <div className="mb-4 p-4 bg-green-50 border border-green-200 rounded-lg">
                <div className="flex items-center mb-2">
                  <CheckCircle className="w-5 h-5 text-green-600 mr-2" />
                  <h4 className="font-medium text-green-900">Paiement validé</h4>
                </div>
                <div className="text-sm text-green-700 space-y-1">
                  <div>Date : {new Date(paiementExistantEmploye.date_paiement).toLocaleDateString('fr-FR')}</div>
                  <div>Montant : {paiementExistantEmploye.montant_net} FCFA</div>
                </div>
              </div>
            ) : null}


              {/* Zone de calcul */}
              {(() => {
                const calcul = calculerRemunerationEmploye(employe);

                const montantAffiche = paiementExistantEmploye
                  ? parseFloat(paiementExistantEmploye.montant_net || 0)
                  : calcul.salaire_net;

                const montantBrut = paiementExistantEmploye
                  ? parseFloat(paiementExistantEmploye.montant_brut || 0)
                  : calcul.salaire_base;

                const montantRetenues = paiementExistantEmploye
                  ? parseFloat(paiementExistantEmploye.montant_retenues || 0)
                  : calcul.total_retenues;

                const montantAvances = paiementExistantEmploye
                  ? parseFloat(paiementExistantEmploye.montant_avances || 0)
                  : calcul.total_avances;

                return (
                  <div className="space-y-4">
                    {/* Résumé du calcul */}
                    <div className="p-4 bg-gradient-to-br from-blue-50 to-indigo-50 rounded-lg border border-blue-200">
                      <h4 className="text-sm font-medium text-blue-900 mb-3 flex items-center">
                        <Calculator className="w-4 h-4 mr-2" />
                        Détail du calcul
                      </h4>

                      <div className="space-y-2 text-sm">
                      <div className="flex justify-between">
                        <span className="text-gray-600">Jours ouvrés du mois :</span>
                        <span className="font-medium">{calcul.jours_ouvres_attendus} jours</span>
                      </div>
                      <div className="flex justify-between">
                        <span className="text-gray-600">Jours pointés :</span>
                        <span className="font-medium">{calcul.jours_pointes} jours</span>
                      </div>

                      {/* ✅ AJOUTE CES NOUVELLES LIGNES */}
                      <div className="flex justify-between text-green-600">
                        <span>• Jours travaillés :</span>
                        <span className="font-medium">{employe.nombre_presences || 0} jours</span>
                      </div>

                      {calcul.vrais_absences > 0 && (
                        <div className="flex justify-between text-red-600">
                          <span>• Absences :</span>
                          <span className="font-medium">{calcul.vrais_absences} jours</span>
                        </div>
                      )}

                      {calcul.jours_non_travailles > 0 && (
                        <div className="flex justify-between text-gray-600">
                          <span>• Jours non travaillés :</span>
                          <span className="font-medium">{calcul.jours_non_travailles} jours</span>
                        </div>
                      )}

                      {calcul.jours_manquants > 0 && (
                        <div className="flex justify-between text-orange-600">
                          <span>• Jours manquants :</span>
                          <span className="font-medium">{calcul.jours_manquants} jours</span>
                        </div>
                      )}
                     </div>

                      <div className="mt-4 pt-4 border-t border-blue-200">
                        <div className="flex justify-between text-sm mb-2">
                          <span className="text-gray-600">Salaire de base :</span>
                          <span className="font-medium">{montantBrut.toLocaleString()} FCFA</span>
                        </div>


                        {(() => {
                        const calcul = calculerRemunerationEmploye(employe);
                        const hasRetenues = calcul.total_retenues > 0;
                        const hasRetenuesPresences = calcul.total_retenues_presences > 0;
                        const hasRetenueGlobale = calcul.retenue_globale > 0;
                        const hasRetenuesEnfants = calcul.retenues_enfants_charge > 0;  // 🆕

                        if (!hasRetenues) return null;

                        return (
                            <div className="space-y-1 mb-2">
                            {/* Retenues absences/retards */}
                            {hasRetenuesPresences && (
                                <div className="flex justify-between text-sm text-red-600">
                                <span>Retenues absences/retards :</span>
                                <span className="font-medium">- {calcul.total_retenues_presences.toLocaleString()} FCFA</span>
                                </div>
                            )}

                            {/* Retenue sur salaire (manuelle) */}
                            {hasRetenueGlobale && (
                                <div className="space-y-1">
                                <div className="flex justify-between text-sm text-red-600">
                                    <span>Retenue sur salaire :</span>
                                    <span className="font-medium">- {calcul.retenue_globale.toLocaleString()} FCFA</span>
                                </div>
                                {employe.justification_retenue_temp && (
                                    <div className="p-2 bg-red-50 border border-red-200 rounded text-xs text-red-700">
                                    <span className="font-medium">Motif : </span>
                                    {employe.justification_retenue_temp}
                                    </div>
                                )}
                                </div>
                            )}



                            {/* 🆕 Retenues enfants à charge (locales + inter-sites) */}
                            {hasRetenuesEnfants && (
                                <div className="space-y-1">
                                <div className="flex justify-between text-sm text-purple-600">
                                    <span className="flex items-center gap-2">
                                    <Users className="w-3.5 h-3.5" />
                                    Retenues enfants à charge :
                                    </span>
                                    <span className="font-medium">- {calcul.retenues_enfants_charge.toLocaleString()} FCFA</span>
                                </div>

                                {/* Détail : Enfants locaux */}
                                {calcul.retenues_enfants_locaux > 0 && (
                                <div className="p-2 bg-purple-50 border border-purple-200 rounded text-xs">
                                    <div className="flex items-center justify-between">
                                    <div className="text-purple-700">
                                        <span className="font-medium">{calcul.nombre_enfants_locaux} enfant(s) sur ce site</span>
                                        <span className="text-purple-600"> — {calcul.retenues_enfants_locaux.toLocaleString()} FCFA</span>
                                    </div>
                                    </div>
                                </div>
                                )}

                                {/* Détail : Enfants inter-sites */}
                                {calcul.retenues_enfants_intersite > 0 && (
                                <div className="p-2 bg-teal-50 border border-teal-200 rounded text-xs">
                                    <div className="flex items-center justify-between">
                                    <div className="text-teal-700">
                                        <span className="font-medium">🌐 {calcul.nombre_enfants_intersite} enfant(s) inter-sites</span>
                                        <span className="text-teal-600"> — {calcul.retenues_enfants_intersite.toLocaleString()} FCFA</span>
                                    </div>
                                    </div>
                                </div>
                                )}

                                {/* Bouton voir détail */}
                                <div className="p-2 bg-gray-50 border border-gray-200 rounded text-xs">
                                    <div className="flex items-center justify-between">
                                    <div className="text-gray-600">
                                        <span className="font-medium">{calcul.nombre_enfants_charge} enfant(s) total</span>
                                        <span> — Déduction automatique</span>
                                    </div>
                                    <button
                                        onClick={() => {
                                            const employe = employes.find(e => e.id.toString() === selectedEmploye);
                                            setSelectedEmployeEnfantsDetail(employe);
                                            setShowModalEnfantsCharge(true);
                                        }}
                                        className="text-purple-600 hover:text-purple-800 hover:underline text-xs font-medium flex items-center gap-1"
                                    >
                                        <Users className="w-3 h-3" />
                                        Voir détail
                                    </button>
                                    </div>
                                </div>
                                </div>
                            )}



                            {/* Total retenues si plusieurs types existent */}
                            {((hasRetenuesPresences && hasRetenueGlobale) ||
                                (hasRetenuesPresences && hasRetenuesEnfants) ||
                                (hasRetenueGlobale && hasRetenuesEnfants) ||
                                (hasRetenuesPresences && hasRetenueGlobale && hasRetenuesEnfants)) && (
                                <div className="flex justify-between text-sm text-red-700 font-bold pt-1 border-t border-red-200">
                                <span>Total retenues :</span>
                                <span>- {calcul.total_retenues.toLocaleString()} FCFA</span>
                                </div>
                            )}
                            </div>
                        );
                        })()}

                        {montantAvances > 0 && (
                          <div className="flex justify-between text-sm text-orange-600 mb-2">
                            <span>Avances sur salaire :</span>
                            <span className="font-medium">- {montantAvances.toLocaleString()} FCFA</span>
                          </div>
                        )}
                        <div className="flex justify-between text-lg font-bold text-blue-900 pt-2 border-t border-blue-300">
                          <span>Salaire net à payer :</span>
                          <span>{montantAffiche.toLocaleString()} FCFA</span>
                        </div>


                        {/* BOUTON UNIQUE RETENUE */}
                        <div className="mt-4 pt-4 border-t border-blue-200">
                          <button
                            onClick={() => {
                              setSelectedPresence({
                                employe_id: employe.id,
                                nom: `${employe.prenom} ${employe.nom}`,
                                type: 'employe'
                              });
                              setRetenueAbsence('');
                              setTypeRetenue('avec');
                              setJustificationPasDeRetenue('');
                              setShowRetenueModal(true);
                            }}
                            disabled={paiementExistantEmploye?.statut === 'cloture'}
                            className="w-full px-4 py-2.5 text-sm bg-[#c66d59] text-white rounded-lg hover:bg-[#b45d4c] transition-colors flex items-center justify-center gap-2 disabled:bg-gray-400 disabled:cursor-not-allowed"
                          >
                            <CreditCard className="w-4 h-4" />
                            Ajouter/Modifier une retenue sur salaire
                          </button>
                        </div>

                      </div>


                    </div>

                    {/* Message d'erreur si jours manquants */}
                    {!calcul.peut_payer && (
                      <div className="p-4 bg-red-50 border border-red-200 rounded-lg">
                        <div className="flex items-start">
                          <AlertTriangle className="w-5 h-5 text-red-600 mr-2 mt-0.5" />
                          <div className="flex-1">
                            <h5 className="font-medium text-red-900 mb-1">Pointages incomplets</h5>
                            <p className="text-sm text-red-700 mb-2">{calcul.message_erreur}</p>
                            <div className="text-xs text-red-600">
                              Dates manquantes : {calcul.dates_manquantes.map(d =>
                                new Date(d).toLocaleDateString('fr-FR')
                              ).join(', ')}
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                );
              })()}



            {/* Message si déjà payé */}
            {paymentValidatedEmploye && (
              <div className="p-3 bg-green-50 border border-green-200 rounded-lg">
                <div className="flex items-center text-sm text-green-800">
                  <CheckCircle className="w-5 h-5 mr-2" />
                  <div>
                    <p className="font-medium">Paiement déjà effectué</p>
                    <p className="text-xs text-green-700">
                      Ce salaire a déjà été payé pour {new Date(selectedDate).toLocaleDateString('fr-FR', { month: 'long', year: 'numeric' })}
                    </p>
                  </div>
                </div>
              </div>
            )}

            <SalaryLockPanel />



            {/* Bouton validation */}
              <button
                onClick={() => {
                  if (salaryPaymentLocked) {
                    localShowToast(getSalaryLockMessage(), 'error');
                    return;
                  }
                  const calcul = calculerRemunerationEmploye(employe);
                  if (calcul.peut_payer) {
                    setShowValidationDialogEmploye(true)
                  } else {
                    setShowJustificationValidationModal(true);
                  }
                }}
                disabled={calculationValidatedEmploye || paymentValidatedEmploye || salaryPaymentLocked}
                className={`w-full py-3 px-4 rounded-lg font-medium transition-colors ${
                  calculationValidatedEmploye || paymentValidatedEmploye || salaryPaymentLocked
                    ? 'bg-gray-400 text-white cursor-not-allowed'
                    : 'bg-[#246990] text-white hover:bg-[#1f5a7a]'
                }`}
              >
                {paymentValidatedEmploye ? (
                  <div className="flex items-center justify-center">
                    <CheckCircle className="w-5 h-5 mr-2" />
                    Déjà payé ce mois
                  </div>
                ) : calculationValidatedEmploye ? (
                  <div className="flex items-center justify-center">
                    <Check className="w-5 h-5 mr-2" />
                    Calcul validé
                  </div>
                ) : (
                  <div className="flex items-center justify-center">
                    <Brain className="w-5 h-5 mr-2" />
                    Valider le calcul
                  </div>
                )}
              </button>
              </div>

            );
          })()}
        </div>



        {/* Section 3: Paiement */}
        <div className="bg-white p-4 rounded-lg border border-gray-200 shadow-sm xl:col-span-2">
          <div className="p-3 bg-[#eef7fb] rounded-lg border border-[#246990]/20 flex items-center mb-4">
            <div className="p-2 bg-[#246990] rounded-full mr-2">
              <CreditCard className="text-white" size={14} />
            </div>
            <div className="flex-1">
              <h2 className="font-medium text-[#246990] text-base">Paiement</h2>
              <p className="text-xs text-gray-600">Validation</p>
            </div>
          </div>

          {/* Entourer avec le flou si clôturé */}
          <SalaryLockPanel />

          <div className={paiementExistantEmploye?.statut === 'cloture' ? 'opacity-50 pointer-events-none' : ''}>
            {!calculationValidatedEmploye ? (
              <div className="text-center py-8 text-gray-400">
                <CreditCard className="h-12 w-12 mx-auto mb-2 opacity-50" />
                <p className="text-xs">Validez le calcul</p>
              </div>
            ) : (() => {
              const employe = employes.find(e => e.id.toString() === selectedEmploye);
              const calcul = calculerRemunerationEmploye(employe);

              const montantAffiche = paiementExistantEmploye
                ? parseFloat(paiementExistantEmploye.montant_net || 0)
                : calcul.salaire_net;

              const montantBrut = paiementExistantEmploye
                ? parseFloat(paiementExistantEmploye.montant_brut || 0)
                : calcul.salaire_base;

              const montantRetenues = paiementExistantEmploye
                ? parseFloat(paiementExistantEmploye.montant_retenues || 0)
                : calcul.total_retenues;

              const montantAvances = paiementExistantEmploye
                ? parseFloat(paiementExistantEmploye.montant_avances || 0)
                : calcul.total_avances;

              if (!calcul) {
                return (
                  <div className="text-center py-8 text-gray-400">
                    <AlertTriangle className="h-12 w-12 mx-auto mb-2 opacity-50" />
                    <p className="text-xs">Données indisponibles</p>
                  </div>
                );
              }

              return (
                <div className="space-y-3">
                  {/* Montant à payer */}
                  <div className="text-center p-3 bg-gradient-to-br from-green-50 to-emerald-50 rounded-lg border border-green-200">
                    <div className="text-xs text-green-600 mb-1 font-medium">Rémunération calculée</div>
                    <div className="text-2xl font-bold text-green-700">
                      {montantAffiche.toLocaleString()} FCFA
                    </div>
                    <div className="text-xs text-green-600 mt-2">
                      Salaire mensuel
                    </div>
                  </div>

                  {/* Actions */}
                  {!paymentValidatedEmploye ? (
                    <div className="space-y-2">
                      <button
                        onClick={handleOpenPaymentDialogEmploye}
                        disabled={salaryPaymentLocked}
                        className="w-full py-2 px-3 bg-[#319190] text-white rounded-lg hover:bg-[#319190]/90 transition-colors text-sm font-medium disabled:cursor-not-allowed disabled:opacity-50"
                      >
                        <div className="flex items-center justify-center">
                          <CreditCard className="w-4 h-4 mr-2" />
                          Effectuer paiement
                        </div>
                      </button>
                    </div>
                  ) : (
                    <div className="space-y-2">
                      {/* Message de confirmation paiement */}
                      <div className="p-3 bg-green-600 text-white rounded-lg text-center">
                        <div className="flex items-center justify-center mb-1">
                          <CheckCircle className="w-5 h-5 mr-2" />
                          <span className="font-medium text-sm">
                            {paiementExistantEmploye?.statut === 'cloture' ? 'Paiement clôturé' : 'Paiement effectué'}
                          </span>
                        </div>
                        <div className="text-xs opacity-90">
                          {paiementExistantEmploye?.date_paiement
                            ? new Date(paiementExistantEmploye.date_paiement).toLocaleDateString('fr-FR')
                            : new Date().toLocaleDateString('fr-FR')
                          }
                        </div>
                      </div>

                      {/* Récapitulatif */}
                      <div className="p-2 bg-gray-50 rounded-lg border border-gray-200 text-xs space-y-1">
                        <div className="flex justify-between">
                          <span className="text-gray-600">Montant:</span>
                          <span className="font-semibold text-gray-900">{montantAffiche.toLocaleString()} FCFA</span>
                        </div>
                        <div className="flex justify-between">
                          <span className="text-gray-600">Salaire brut:</span>
                          <span className="font-medium text-gray-900">{montantBrut.toLocaleString()} FCFA</span>
                        </div>
                        {montantRetenues > 0 && (
                          <div className="flex justify-between text-red-600">
                            <span>Retenues:</span>
                            <span className="font-medium">-{montantRetenues.toLocaleString()} FCFA</span>
                          </div>
                        )}
                        {montantAvances > 0 && (
                          <div className="flex justify-between text-orange-600">
                            <span>Avances:</span>
                            <span className="font-medium">-{montantAvances.toLocaleString()} FCFA</span>
                          </div>
                        )}
                      </div>

                      {/* Boutons selon statut */}
                      {paiementExistantEmploye?.statut !== 'cloture' ? (
                        <>

                          {/* Pas de bouton clôture - fait automatiquement */}


                        </>
                      ) : (
                        <>
                          <div className="p-3 bg-red-50 border border-red-200 rounded-lg">
                            <div className="flex items-center text-xs text-red-700">
                              <AlertTriangle className="w-4 h-4 mr-2" />
                              <span>Paiement clôturé - Aucune modification possible</span>
                            </div>
                          </div>


                        </>
                      )}
                    </div>
                  )}
                </div>
              );
            })()}
          </div>
        </div>

        </div>




      {/* Message informatif */}
      <div className="mt-6 p-4 bg-[#eef7fb] rounded-lg border border-[#246990]/20 flex items-center">
        <div className="p-2 bg-[#246990] rounded-full mr-4">
          <Building className="text-white" size={20} />
        </div>
        <div className="flex-1">
          <h5 className="font-medium text-[#246990]">Gestion du personnel administratif</h5>
          <p className="text-sm text-gray-600">
            Calculs basés sur les salaires fixes mensuels, primes d'ancienneté et de responsabilité.
            Gestion des heures supplémentaires et des absences selon la convention collective.
          </p>
        </div>
      </div>




      {/* Modale Justification Décalage */}
      {showJustificationModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4">
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-lg font-semibold text-gray-900">Justifier le décalage</h3>
              <button onClick={() => setShowJustificationModal(false)} className="text-gray-400 hover:text-gray-600">
                <X className="w-5 h-5" />
              </button>
            </div>

            <div className="mb-4">
              <p className="text-sm text-gray-600 mb-2">
                Pointage prévu le {new Date(selectedPresence?.date).toLocaleDateString('fr-FR')},
                effectué le {new Date(selectedPresence?.date_reelle_pointage).toLocaleDateString('fr-FR')}
              </p>
              <p className="text-sm font-medium text-orange-600">
                Décalage : {selectedPresence?.jours_decalage} jour(s)
              </p>
            </div>

            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Justification *
              </label>
              <textarea
                value={justificationDecalage}
                onChange={(e) => setJustificationDecalage(e.target.value)}
                placeholder="Expliquez la raison du décalage..."
                className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#246990] focus:border-transparent"
                rows="4"
              />
            </div>

            <div className="flex gap-3">
              <button
                onClick={() => setShowJustificationModal(false)}
                className="flex-1 px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50"
              >
                Annuler
              </button>
              <button
                onClick={handleSaveJustificationDecalage}
                disabled={loading}
                className="flex-1 px-4 py-2 bg-[#246990] text-white rounded-lg hover:bg-[#1f5a7a] disabled:bg-gray-400"
              >
                {loading ? 'Enregistrement...' : 'Enregistrer'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modale Retenue - VERSION GLOBALE */}
      {showRetenueModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4">
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-lg font-semibold text-gray-900">Gérer les retenues sur salaire</h3>
              <button onClick={() => setShowRetenueModal(false)} className="text-gray-400 hover:text-gray-600">
                <X className="w-5 h-5" />
              </button>
            </div>

            {/* Affichage employé/enseignant */}
            <div className="mb-4 p-3 bg-blue-50 rounded-lg">
              <p className="text-sm font-medium text-blue-900">
                {selectedPresence?.nom}
              </p>
              <p className="text-xs text-blue-700">
                Période : {formatDateForDisplay(selectedDate)}
              </p>
            </div>

            {/* Choix du type */}
            <div className="mb-4">
              <div className="flex gap-3">
                <label className="flex-1 cursor-pointer">
                  <input
                    type="radio"
                    value="avec"
                    checked={typeRetenue === 'avec'}
                    onChange={(e) => setTypeRetenue(e.target.value)}
                    className="sr-only"
                  />
                  <div className={`p-3 rounded-lg border-2 text-center transition-colors ${
                    typeRetenue === 'avec'
                      ? 'border-red-600 bg-red-50'
                      : 'border-gray-300 hover:border-gray-400'
                  }`}>
                    <div className="text-sm font-medium">Appliquer une retenue</div>
                  </div>
                </label>
                <label className="flex-1 cursor-pointer">
                  <input
                    type="radio"
                    value="sans"
                    checked={typeRetenue === 'sans'}
                    onChange={(e) => setTypeRetenue(e.target.value)}
                    className="sr-only"
                  />
                  <div className={`p-3 rounded-lg border-2 text-center transition-colors ${
                    typeRetenue === 'sans'
                      ? 'border-green-600 bg-green-50'
                      : 'border-gray-300 hover:border-gray-400'
                  }`}>
                    <div className="text-sm font-medium">Pas de retenue</div>
                  </div>
                </label>
              </div>
            </div>

            {/* Champs pour AVEC retenue */}
            {typeRetenue === 'avec' && (
              <>
                {/* Montant de la retenue */}
                <div className="mb-4">
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Montant de la retenue (FCFA) *
                  </label>
                  <input
                    type="number"
                    value={retenueAbsence}
                    onChange={(e) => setRetenueAbsence(e.target.value)}
                    placeholder="Ex: 5000"
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#246990] focus:border-transparent"
                  />
                </div>

                {/* Justification de la retenue */}
                <div className="mb-4">
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Motif de la retenue *
                  </label>
                  <textarea
                    value={justificationPasDeRetenue}
                    onChange={(e) => setJustificationPasDeRetenue(e.target.value)}
                    placeholder="Ex: Absence injustifiée, retard répété, manquement professionnel..."
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#246990] focus:border-transparent"
                    rows="3"
                  />
                </div>
              </>
            )}

            {/* Champ justification SANS retenue */}
            {typeRetenue === 'sans' && (
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Justification de l'absence de retenue *
                </label>
                <textarea
                  value={justificationPasDeRetenue}
                  onChange={(e) => setJustificationPasDeRetenue(e.target.value)}
                  placeholder="Ex: Congé maladie justifié, autorisation exceptionnelle..."
                  className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#246990] focus:border-transparent"
                  rows="3"
                />
              </div>
            )}

            <div className="flex gap-3">
              <button
                onClick={() => setShowRetenueModal(false)}
                className="flex-1 px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50"
              >
                Annuler
              </button>
              <button
                onClick={handleSaveRetenueAbsence}
                disabled={loading}
                className="flex-1 px-4 py-2 bg-[#246990] text-white rounded-lg hover:bg-[#1f5a7a] disabled:bg-gray-400"
              >
                {loading ? 'Enregistrement...' : 'Enregistrer'}
              </button>
            </div>
          </div>
        </div>
      )}


{/* 🆕 ============================================================================ */}
{/* 🆕 MODAL DÉTAIL ENFANTS À CHARGE - VERSION COMPACTE & CORPORATE */}
{/* 🆕 ============================================================================ */}
{showModalEnfantsCharge && selectedEmployeEnfantsDetail && (
  <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-[9999] p-4">
    <div className="bg-white rounded-lg shadow-2xl max-w-lg w-full max-h-[85vh] overflow-hidden flex flex-col">
      {/* Header Compact */}
      <div className="bg-gradient-to-r from-[#3084b5] to-[#319190] px-5 py-4 text-white">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="p-2 bg-white/20 rounded-lg">
              <Users className="w-5 h-5" />
            </div>
            <div>
              <h3 className="text-lg font-semibold">Enfants à Charge</h3>
              <p className="text-white/90 text-xs">
                {selectedEmployeEnfantsDetail.prenom} {selectedEmployeEnfantsDetail.nom}
              </p>
            </div>
          </div>
          <button
            onClick={() => setShowModalEnfantsCharge(false)}
            className="p-1.5 hover:bg-white/20 rounded-lg transition-colors"
          >
            <X className="w-5 h-5" />
          </button>
        </div>
      </div>

      {/* Content */}
      <div className="flex-1 overflow-y-auto p-5">
        {(() => {
          const calcul = calculerRemunerationEmploye(selectedEmployeEnfantsDetail);

          if (calcul.nombre_enfants_charge === 0) {
            return (
              <div className="text-center py-8 text-gray-400">
                <Users className="w-12 h-12 mx-auto mb-3 opacity-50" />
                <p className="text-sm font-medium text-gray-700">Aucun enfant à charge</p>
                <p className="text-xs text-gray-500 mt-1">Pas de déduction active</p>
              </div>
            );
          }

          const enfants = Array.isArray(calcul.detail_enfants_charge)
            ? calcul.detail_enfants_charge
            : [];

          return (
            <div className="space-y-4">


             {/* Statistiques compactes */}
              <div className={`grid ${calcul.retenues_enfants_intersite > 0 ? 'grid-cols-3' : 'grid-cols-2'} gap-3`}>
                <div className="bg-blue-50 rounded-lg p-3 border border-blue-100">
                  <p className="text-xs text-blue-600 font-medium mb-1">Enfants</p>
                  <p className="text-2xl font-bold text-blue-900">{calcul.nombre_enfants_charge}</p>
                  {calcul.nombre_enfants_intersite > 0 && (
                    <p className="text-[10px] text-blue-500">{calcul.nombre_enfants_locaux} local + {calcul.nombre_enfants_intersite} inter-sites</p>
                  )}
                </div>
                <div className="bg-purple-50 rounded-lg p-3 border border-purple-100">
                  <p className="text-xs text-purple-600 font-medium mb-1">Retenue totale</p>
                  <p className="text-xl font-bold text-purple-900">
                    {calcul.retenues_enfants_charge.toLocaleString()}
                  </p>
                  <p className="text-xs text-purple-600">FCFA</p>
                </div>
                {calcul.retenues_enfants_intersite > 0 && (
                  <div className="bg-teal-50 rounded-lg p-3 border border-teal-100">
                    <p className="text-xs text-teal-600 font-medium mb-1">🌐 Inter-sites</p>
                    <p className="text-xl font-bold text-teal-900">
                      {calcul.retenues_enfants_intersite.toLocaleString()}
                    </p>
                    <p className="text-xs text-teal-600">FCFA</p>
                  </div>
                )}
              </div>



              {/* Liste des enfants LOCAUX */}
              {enfants.length > 0 && (
              <div>
                <h4 className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-2">
                  Enfants scolarisés sur ce site
                </h4>
                <div className="space-y-2">
                  {enfants.map((enfant, index) => (
                    <div
                      key={enfant.eleve_id}
                      className="bg-white rounded-lg border border-gray-200 p-3 hover:border-[#3084b5] transition-colors"
                    >
                      <div className="flex items-center justify-between">
                        <div className="flex items-center gap-2.5 flex-1 min-w-0">
                          <div className="w-8 h-8 bg-gradient-to-br from-[#3084b5] to-[#319190] rounded-full flex items-center justify-center text-white text-xs font-bold flex-shrink-0">
                            {enfant.prenom?.charAt(0)}{enfant.nom?.charAt(0)}
                          </div>
                          <div className="flex-1 min-w-0">
                            <p className="font-medium text-gray-900 text-sm truncate">
                              {enfant.prenom} {enfant.nom}
                            </p>
                            <div className="flex items-center gap-2 text-xs text-gray-500">
                              <span className="flex items-center gap-1">
                                <BookOpen className="w-3 h-3" />
                                {enfant.classe}
                              </span>
                              <span className="text-gray-300">•</span>
                              <span className="flex items-center gap-1">
                                <Badge className="w-3 h-3" />
                                {enfant.matricule}
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="text-right ml-2">
                          <p className="text-sm font-bold text-[#3084b5]">
                            {enfant.montant.toLocaleString()}
                          </p>
                          <p className="text-xs text-gray-500">FCFA</p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              )}

              {/* 🌐 Liste des enfants INTER-SITES */}
              {(() => {
                const intersiteEnfants = calcul.detail_enfants_intersite || [];
                if (intersiteEnfants.length === 0) return null;

                return (
                  <div>
                    <h4 className="text-xs font-semibold text-teal-600 uppercase tracking-wide mb-2 flex items-center gap-2">
                      🌐 Enfants scolarisés sur d'autres sites
                    </h4>
                    <div className="space-y-2">
                      {intersiteEnfants.map((enfant, index) => (
                        <div
                          key={enfant.link_id || index}
                          className="bg-white rounded-lg border border-teal-200 p-3 hover:border-teal-400 transition-colors"
                        >
                          <div className="flex items-center justify-between">
                            <div className="flex items-center gap-2.5 flex-1 min-w-0">
                              <div className="w-8 h-8 bg-gradient-to-br from-teal-500 to-teal-700 rounded-full flex items-center justify-center text-white text-xs font-bold flex-shrink-0">
                                🌐
                              </div>
                              <div className="flex-1 min-w-0">
                                <p className="font-medium text-gray-900 text-sm truncate">
                                  {enfant.nom_complet || enfant.nom}
                                </p>
                                <div className="flex items-center gap-2 text-xs text-gray-500">
                                  {enfant.classe_nom && (
                                    <>
                                      <span className="flex items-center gap-1">
                                        <BookOpen className="w-3 h-3" />
                                        {enfant.classe_nom}
                                      </span>
                                      <span className="text-gray-300">•</span>
                                    </>
                                  )}
                                  <span className="flex items-center gap-1 text-teal-600 font-medium">
                                    <Building className="w-3 h-3" />
                                    {enfant.site_label || enfant.site_subdomain}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div className="text-right ml-2">
                              <p className="text-sm font-bold text-teal-600">
                                {(enfant.montant || 0).toLocaleString()}
                              </p>
                              <p className="text-xs text-gray-500">FCFA</p>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                );
              })()}



              {/* Note informative compacte */}
              <div className="bg-blue-50 border border-blue-200 rounded-lg p-3">
                <div className="flex gap-2">
                  <AlertCircle className="w-4 h-4 text-blue-600 flex-shrink-0 mt-0.5" />
                  <p className="text-xs text-blue-800 leading-relaxed">
                   Ces montants sont automatiquement déduits du salaire mensuel.
                    {calcul.retenues_enfants_intersite > 0
                      ? `${calcul.nombre_enfants_locaux} enfant(s) sur ce site et ${calcul.nombre_enfants_intersite} sur un autre site du groupe.`
                      : 'Déduction pour chaque enfant scolarisé dans l\'établissement.'
                    }
                  </p>
                </div>
              </div>
            </div>
          );
        })()}
      </div>

      {/* Footer Corporate */}
      <div className="px-5 py-3 bg-gray-50 border-t border-gray-200">
        <div className="flex justify-between items-center">
          <p className="text-xs text-gray-500">
            📅 {formatDateForDisplay(selectedDate)}
          </p>
          <button
            onClick={() => setShowModalEnfantsCharge(false)}
            className="px-4 py-1.5 bg-[#3084b5] text-white rounded-md hover:bg-[#2a6d9a] transition-colors text-sm font-medium"
          >
            Fermer
          </button>
        </div>
      </div>
    </div>
  </div>
)}


      {/* Modale Justification Validation avec pointages manquants */}
      {showJustificationValidationModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4">
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-lg font-semibold text-gray-900">Justification requise</h3>
              <button
                onClick={() => {
                  setShowJustificationValidationModal(false);
                  setJustificationValidation('');
                }}
                className="text-gray-400 hover:text-gray-600"
              >
                <X className="w-5 h-5" />
              </button>
            </div>

            <div className="mb-4 p-3 bg-orange-50 border border-orange-200 rounded-lg">
              <div className="flex items-start">
                <AlertTriangle className="w-5 h-5 text-orange-600 mr-2 mt-0.5" />
                <div className="text-sm text-orange-800">
                  {(() => {
                    const employe = employes.find(e => e.id.toString() === selectedEmploye);
                    const calcul = calculerRemunerationEmploye(employe);
                    return (
                      <>
                        <p className="font-medium mb-1">
                          {calcul.jours_manquants} jour(s) sans pointage
                        </p>
                        <p className="text-xs">
                          Vous devez justifier pourquoi vous validez malgré les pointages manquants.
                        </p>
                      </>
                    );
                  })()}
                </div>
              </div>
            </div>

            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Justification *
              </label>
              <textarea
                value={justificationValidation}
                onChange={(e) => setJustificationValidation(e.target.value)}
                placeholder="Expliquez pourquoi vous validez malgré les pointages manquants..."
                className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#246990] focus:border-transparent"
                rows="4"
              />
            </div>

            <div className="flex gap-3">
              <button
                onClick={() => {
                  setShowJustificationValidationModal(false);
                  setJustificationValidation('');
                }}
                className="flex-1 px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors"
              >
                Annuler
              </button>
              <button
                onClick={() => {
                  if (!justificationValidation.trim()) {
                    localShowToast('Veuillez saisir une justification', 'error');
                    return;
                  }
                  setShowJustificationValidationModal(false);
                  setShowValidationDialogEmploye(true);
                }}
                className="flex-1 px-4 py-2 bg-[#246990] text-white rounded-lg hover:bg-[#1f5a7a] transition-colors"
              >
                Continuer
              </button>
            </div>
          </div>
        </div>
      )}


      {/* Dialog Historique des paiements */}

        {showHistoriqueEmployes && (
          <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-lg shadow-xl max-w-7xl w-full max-h-[90vh] overflow-hidden flex flex-col">
              {/* Header avec bouton fermer */}
              <div className="p-4 bg-gradient-to-r from-[#246990] to-[#1f5a7a] flex items-center justify-between">
                <h2 className="text-xl font-bold text-white">Historique des paiements</h2>
                <button
                  onClick={() => setShowHistoriqueEmployes(false)}
                  className="text-white hover:bg-white/20 rounded-lg p-2 transition-colors"
                >
                  <X className="w-6 h-6" />
                </button>
              </div>

              {/* Nouveau composant historique */}
              <div className="flex-1 overflow-y-auto">
                <EmployeePaimentHistory
                  show={showHistoriqueEmployes}
                  onClose={() => setShowHistoriqueEmployes(false)}
                  loadData={async () => {
                    try {
                      console.log('📊 Chargement historique employés...');
                      const response = await api.paiementsSalaires.getHistoriquePaiementsEmployes();

                      if (response.success) {
                        console.log(`✅ ${response.data?.length || 0} paiements trouvés`);
                        return response.data || [];
                      } else {
                        console.error('❌ Erreur:', response.message);
                        localShowToast('Erreur lors du chargement de l\'historique', 'error');
                        return [];
                      }
                    } catch (error) {
                      console.error('❌ Erreur chargement historique:', error);
                      localShowToast('Erreur lors du chargement de l\'historique', 'error');
                      return [];
                    }
                  }}
                  onDownloadFiche={handleDownloadFichePaieEmploye}
                  showToast={localShowToast}
                />
              </div>
            </div>
          </div>
        )}


       <ConfirmDialog
        isOpen={showValidationDialogEmploye}
        onClose={() => setShowValidationDialogEmploye(false)}
        onConfirm={handleValidateCalculationEmploye}
        title="Valider le calcul"
        description="Voulez-vous valider ce calcul de rémunération et l'envoyer vers le module de paiement ?"
        confirmText="Valider"
        cancelText="Annuler"
        type="question"
      />


      {/* Dialog de validation avec chargement */}
      {isValidatingEmploye && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[10001]">
          <div className="bg-white rounded-lg p-8 max-w-md w-full mx-4">
            <div className="text-center">
              <div className="mb-6">
                <div className="w-16 h-16 mx-auto bg-[#246990] rounded-full flex items-center justify-center animate-pulse">
                  <Calculator className="text-white" size={32} />
                </div>
              </div>

              <h3 className="text-xl font-semibold text-gray-900 mb-2">
                Validation en cours
              </h3>
              <p className="text-gray-600 mb-6">
                Calcul en cours de validation et envoi vers le paiement...
              </p>

              <motion.div
                className="w-full h-2 bg-gray-200 rounded-full overflow-hidden"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
              >
                <motion.div
                  className="h-full bg-[#246990]"
                  initial={{ width: "0%" }}
                  animate={{ width: "100%" }}
                  transition={{ duration: 3, ease: "easeInOut" }}
                />
              </motion.div>
            </div>
          </div>
        </div>
      )}
          {/* Dialog de paiement employé */}
        <ConfirmDialog
        isOpen={showPaymentDialogEmploye && !isProcessingPaymentEmploye}
        onClose={() => setShowPaymentDialogEmploye(false)}
        onConfirm={handleProcessPaymentEmploye}
        title="Effectuer le paiement"
        description={
            <div className="space-y-3">
            <p>Confirmez le paiement du salaire pour cet employé.</p>
            <div className="bg-blue-50 p-3 rounded-lg">
                <div className="text-sm font-medium text-blue-900">
                Montant : {(() => {
                    const emp = employes.find(e => e.id.toString() === selectedEmploye);
                    const calc = calculerRemunerationEmploye(emp);
                    return calc ? calc.salaire_net.toLocaleString() : '0';
                })()} FCFA
                </div>
            </div>


           <div>
  <label className="block text-sm font-medium text-gray-700 mb-2">
    Mode de paiement *
  </label>

  <div className="relative mode-paiement-dropdown">
    <Search className="absolute left-3 top-3 h-4 w-4 text-gray-400 pointer-events-none z-10" />

    <input
      type="text"
      placeholder="Rechercher un mode de paiement..."
      value={(() => {
        if (selectedModePaiementEmploye) {
          const mode = modesPaiement.find(m => m.id.toString() === selectedModePaiementEmploye);
          return mode ? mode.nom : '';
        }
        return modePaiementSearchTerm;
      })()}
      onChange={(e) => {
        setModePaiementSearchTerm(e.target.value);
        setIsModePaiementDropdownOpen(true);
        if (selectedModePaiementEmploye) {
          setSelectedModePaiementEmploye('');
        }
      }}
      onFocus={() => setIsModePaiementDropdownOpen(true)}
      className="w-full pl-10 pr-10 py-2.5 text-sm border-2 border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#3084b5] focus:border-[#3084b5] transition-all"
    />

    <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
      <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
      </svg>
    </div>

    {/* ✅ Dropdown vers le BAS */}
    {isModePaiementDropdownOpen && !selectedModePaiementEmploye && (
      <div className="absolute z-20 w-full top-full mt-1 bg-white border-2 border-gray-200 rounded-lg shadow-xl max-h-64 overflow-y-auto">
        {(() => {
          const filteredModes = modesPaiement.filter(mode =>
            mode.nom.toLowerCase().includes(modePaiementSearchTerm.toLowerCase())
          );

          if (filteredModes.length === 0) {
            return (
              <div className="p-4 text-center text-gray-500 text-sm">
                Aucun mode de paiement trouvé
              </div>
            );
          }

          return filteredModes.map((mode) => (
            <div
              key={mode.id}
              onClick={() => {
                setSelectedModePaiementEmploye(mode.id.toString());
                setModePaiementSearchTerm('');
                setIsModePaiementDropdownOpen(false);
              }}
              className="px-4 py-3 hover:bg-[#3084b5]/10 cursor-pointer border-b last:border-b-0 transition-colors group"
            >
              <div className="flex items-center gap-3">
                <div className="flex-shrink-0 w-8 h-8 bg-[#3084b5]/10 rounded-lg flex items-center justify-center group-hover:bg-[#3084b5] transition-colors">
                  <CreditCard className="w-4 h-4 text-[#3084b5] group-hover:text-white transition-colors" />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="font-medium text-gray-900 text-sm group-hover:text-[#3084b5] transition-colors">
                    {mode.nom}
                  </div>
                </div>
              </div>
            </div>
          ));
        })()}
      </div>
    )}
  </div>
</div>



            </div>
        }
        confirmText="Confirmer le paiement"
        cancelText="Annuler"
        type="question"
        />



        {/* Dialog de traitement du paiement employé */}
        {isProcessingPaymentEmploye && (() => {
  const employe = employes.find(e => e.id.toString() === selectedEmploye);
  const calcul = calculerRemunerationEmploye(employe);
  const hasEnfantsCharge = calcul.nombre_enfants_charge > 0;
  const isClotureStep = paymentStep === 'cloture';

  return (
    <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-[10001]">
      <div className="bg-white rounded-lg p-8 max-w-2xl w-full mx-4">
        {/* Header */}
        <div className="text-center mb-6">
          <div className={`w-20 h-20 mx-auto rounded-full flex items-center justify-center animate-pulse mb-4 shadow-lg ${
            isClotureStep
              ? 'bg-gradient-to-br from-[#319190] to-[#3084b5]'
              : 'bg-gradient-to-br from-[#3084b5] to-[#319190]'
          }`}>
            {isClotureStep ? (
              <Check className="text-white" size={36} />
            ) : (
              <CreditCard className="text-white" size={36} />
            )}
          </div>

          <h3 className="text-2xl font-bold text-gray-900 mb-2">
            {isClotureStep ? 'Clôture du paiement' : 'Traitement du paiement'}
          </h3>
          <p className="text-gray-600">
            {isClotureStep
              ? 'Finalisation en cours...'
              : `Enregistrement en cours pour ${employe?.prenom} ${employe?.nom}`
            }
          </p>

          {/* Indicateur d'étape */}
          <div className="flex items-center justify-center gap-2 mt-4">
            <div className={`flex items-center justify-center w-8 h-8 rounded-full text-xs font-bold ${
              isClotureStep ? 'bg-[#319190] text-white' : 'bg-[#3084b5] text-white'
            }`}>
              {isClotureStep ? '✓' : '1'}
            </div>
            <div className={`h-1 w-12 ${isClotureStep ? 'bg-[#319190]' : 'bg-gray-300'}`}></div>
            <div className={`flex items-center justify-center w-8 h-8 rounded-full text-xs font-bold ${
              isClotureStep ? 'bg-[#319190] text-white' : 'bg-gray-300 text-gray-600'
            }`}>
              2
            </div>
          </div>
        </div>

        {/* Contenu selon l'étape */}
        {!isClotureStep ? (
          /* ÉTAPE 1 : PAIEMENT */
          <div className="space-y-4 mb-6">
            {/* Salaire */}
            <div className="p-4 bg-[#3084b5]/10 rounded-lg border-2 border-[#3084b5]/30">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 bg-[#3084b5] rounded-lg flex items-center justify-center shadow-md">
                    <Banknote className="text-white" size={20} />
                  </div>
                  <div>
                    <p className="text-sm text-[#3084b5] font-semibold">Salaire mensuel</p>
                    <p className="text-xs text-[#3084b5]/70">
                      {formatDateForDisplay(selectedDate)}
                    </p>
                  </div>
                </div>
                <div className="text-right">
                  <p className="text-lg font-bold text-[#3084b5]">
                    {calcul.salaire_net.toLocaleString()} FCFA
                  </p>
                  <p className="text-xs text-[#3084b5]/70">Net à payer</p>
                </div>
              </div>
            </div>

            {/* Enfants à charge SI présents */}
            {hasEnfantsCharge && (
              <div className="p-4 bg-purple-50 rounded-lg border-2 border-purple-300">
                <div className="flex items-start justify-between mb-3">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 bg-purple-600 rounded-lg flex items-center justify-center shadow-md">
                      <Users className="text-white" size={20} />
                    </div>
                    <div>
                      <p className="text-sm text-purple-700 font-semibold">
                        Frais scolaires - Enfants à charge
                      </p>
                      <p className="text-xs text-purple-600">
                        {calcul.nombre_enfants_charge} enfant(s) scolarisé(s)
                      </p>
                    </div>
                  </div>
                  <div className="text-right">
                    <p className="text-lg font-bold text-purple-700">
                      {calcul.retenues_enfants_charge.toLocaleString()} FCFA
                    </p>
                    <p className="text-xs text-purple-600">Déduits automatiquement</p>
                  </div>
                </div>

                {/* Liste des enfants */}
                <div className="space-y-1.5 mt-3 pt-3 border-t border-purple-200">
                  {calcul.detail_enfants_charge.map((enfant, index) => (
                    <div key={index} className="flex items-center justify-between text-xs">
                      <span className="text-purple-700">
                        <BookOpen className="w-3 h-3 inline mr-1" />
                        {enfant.prenom} {enfant.nom} - {enfant.classe}
                      </span>
                      <span className="font-medium text-purple-800">
                        {enfant.montant.toLocaleString()} FCFA
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Message automatique */}
            {hasEnfantsCharge && (
              <div className="p-4 bg-[#319190]/10 border-2 border-[#319190]/30 rounded-lg">
                <div className="flex items-start gap-3">
                  <CheckCircle className="w-5 h-5 text-[#319190] flex-shrink-0 mt-0.5" />
                  <div className="flex-1">
                    <p className="text-sm font-semibold text-[#319190] mb-1">
                      Paiement automatique des frais scolaires
                    </p>
                    <p className="text-xs text-gray-700 leading-relaxed">
                      Les frais de scolarité de {calcul.nombre_enfants_charge} enfant(s) sont
                      automatiquement réglés et les statuts de paiement mis à jour dans le module
                      de gestion scolaire.
                    </p>
                  </div>
                </div>
              </div>
            )}
          </div>
        ) : (
          /* ÉTAPE 2 : CLÔTURE */
          <div className="space-y-4 mb-6">
            <div className="p-6 bg-[#319190]/10 rounded-lg border-2 border-[#319190]/40 text-center">
              <CheckCircle className="w-16 h-16 text-[#319190] mx-auto mb-4" />
              <h4 className="text-lg font-bold text-gray-900 mb-2">
                Finalisation du paiement
              </h4>
              <p className="text-sm text-gray-700">
                Le paiement est en cours de clôture définitive.
                <br />
                Cette opération est irréversible.
              </p>
            </div>
          </div>
        )}

        {/* Barre de progression */}
        <div className="space-y-2">
          <div className="flex items-center justify-between text-sm text-gray-600">
            <span className="font-medium">
              {isClotureStep ? 'Étape 2/2 : Clôture...' : 'Étape 1/2 : Paiement...'}
            </span>
            <span className="flex items-center gap-1 text-[#3084b5] font-semibold">
              <Clock className="w-4 h-4" />
              {isClotureStep ? '5 secondes' : '8 secondes'}
            </span>
          </div>
          <motion.div
            className="w-full h-3 bg-gray-200 rounded-full overflow-hidden shadow-inner"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
          >
            <motion.div
              className={`h-full shadow-lg ${
                isClotureStep
                  ? 'bg-gradient-to-r from-[#319190] to-[#3084b5]'
                  : 'bg-gradient-to-r from-[#3084b5] to-[#319190]'
              }`}
              key={paymentStep}
              initial={{ width: "0%" }}
              animate={{ width: "100%" }}
              transition={{ duration: isClotureStep ? 5 : 8, ease: "easeInOut" }}
            />
          </motion.div>
        </div>
      </div>
    </div>
  );
})()}



      </div>
    </div>

    <SalaryModificationRequestModal
      open={!!salaryRequestEmploye}
      employee={salaryRequestEmploye}
      selectedDate={selectedDate}
      anneeActive={anneeActive}
      typePersonnel="personnel"
      onClose={() => setSalaryRequestEmploye(null)}
      onSuccess={loadEmployesData}
      showToast={localShowToast}
    />

    <SalaryModificationHistoryModal
      open={!!salaryHistoryEmploye}
      employee={salaryHistoryEmploye}
      selectedDate={selectedDate}
      anneeActive={anneeActive}
      onClose={() => setSalaryHistoryEmploye(null)}
      showToast={localShowToast}
    />

    {toast.show && (
      <Toast
        show={toast.show}
        message={toast.message}
        type={toast.type}
        onClose={() => setToast({ show: false, message: '', type: '' })}
      />
    )}
    </div>
  );
};

export default ComptabilitePersonnel;
